import firebase from 'firebase/compat';
import { httpsCallable } from 'firebase/functions';
import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { v4 } from 'uuid';
import { functions, storage } from './firebase';

export const uploadImage = async (file: File): Promise<string> => {
    const extension = file.type.split('/').pop();
    const filename = `${v4()}.${extension}`;
    const storageRef = ref(storage, filename);
    return uploadBytes(storageRef, file).then(async (snapshot) => {
        return getDownloadURL(snapshot.ref);
    });
};

export const getPathStorageFromUrl = (url: string): string => {
    const baseUrl = 'https://firebasestorage.googleapis.com/v0/b/userlogin-40478.appspot.com/o/';
    let imagePath: string = url.replace(baseUrl, '');
    const indexOfEndPath = imagePath.indexOf('?');
    imagePath = imagePath.substring(0, indexOfEndPath);
    imagePath = imagePath.replace('%2F', '/');
    return imagePath;
};

export const deleteImageFile = async (url: string): Promise<void> => {
    const imagePath: string = getPathStorageFromUrl(url);
    const imageToBeDeleted = ref(storage, imagePath);
    deleteObject(imageToBeDeleted);
};

export const registerProducerOnStripe = async (emailId: string, id: string): Promise<string> => {
    const data = {
        emailId,
        id
    };
    const upload: firebase.functions.HttpsCallable = httpsCallable(functions, 'createAccount');
    return upload(data)
        .then((result) => {
            return result.data;
        })
        .catch((error) => {
            return error;
        });
};

export const amosubscription = async (id: string): Promise<string> => {
    const data = {
        stripeId: id
    };
    const upload: firebase.functions.HttpsCallable = httpsCallable(
        functions,
        'getStripeDashboardLink'
    );
    return upload(data)
        .then((result) => {
            return result.data;
        })
        .catch((error) => {
            return error;
        });
};

export const getClientProfilePhoto = async (path: string): Promise<void | string> => {
    const starsRef = ref(storage, path);
    const url = await getDownloadURL(starsRef);
    return url;
};
